import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from 'react';
import { useNicService } from 'stores/nic/useNicService';
import { KeypadGrid, KeypadKey, KeypadDigit, KeypadLetters, KeypadSequence } from './styled';
var KEYS = [
    [{ digit: '1' }, { digit: '2', letters: 'ABC' }, { digit: '3', letters: 'DEF' }],
    [{ digit: '4', letters: 'GHI' }, { digit: '5', letters: 'JKL' }, { digit: '6', letters: 'MNO' }],
    [{ digit: '7', letters: 'PQRS' }, { digit: '8', letters: 'TUV' }, { digit: '9', letters: 'WXYZ' }],
    [{ digit: '*' }, { digit: '0', letters: '+' }, { digit: '#' }]
];
var VALID_DIGITS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '#'];
var DTMFKeypad = function () {
    var sendDtmfTone = useNicService().sendDtmfTone;
    var _a = useState(''), sequence = _a[0], setSequence = _a[1];
    var handleKey = useCallback(function (digit) {
        sendDtmfTone(digit);
        setSequence(function (prev) { return prev + digit; });
    }, [sendDtmfTone]);
    useEffect(function () {
        var handleKeyPress = function (event) {
            var key = event.key;
            if (VALID_DIGITS.includes(key)) {
                event.preventDefault();
                handleKey(key);
            }
        };
        window.addEventListener('keydown', handleKeyPress);
        return function () { return window.removeEventListener('keydown', handleKeyPress); };
    }, [handleKey]);
    return (_jsxs(_Fragment, { children: [_jsx(KeypadSequence, { children: sequence || ' ' }), _jsx(KeypadGrid, { children: KEYS.flat().map(function (_a) {
                    var digit = _a.digit, letters = _a.letters;
                    return (_jsxs(KeypadKey, { onClick: function () { return handleKey(digit); }, children: [_jsx(KeypadDigit, { children: digit }), letters && _jsx(KeypadLetters, { children: letters })] }, digit));
                }) })] }));
};
export default DTMFKeypad;
